import { gql } from "@/__generated__/gql";

export const DESTROY_BULK_MESSAGE_MUTATION = gql(`
 mutation DestroyBulkMessage(
  $bulkMessageId: ID!
) {
  destroyBulkMessageMutation(input: {
    bulkMessageId: $bulkMessageId
  }) {
    success
    errors {
      title
      message
    }
  }
}
`);
